// -*- Mode: rjsx -*-
import React from 'react';
import axios from 'axios';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import FancyActionTypes from '../data/FancyActionTypes';
import { Spinner } from '../ui/Spinner';
import FancyDate from '../ui/FancyDate';
import { AvatarInline } from '../ui/Avatar';

import Morty from '../data/Morty';
import RealtimeClient from '../data/RealtimeClient';

class ChatMessageCreate extends React.Component {
    constructor(props) {
	super(props);
	this.handler = this.handler.bind(this);
	this.send = this.send.bind(this);	
	this.state = { body: '', textAreaId: 'ta-' + Math.ceil(Math.random() * 1000) };
    }

    send(unused) {
	let self = this;
	let chat = this.props.chat;
	let params = { permission: chat.channel,
		       channel: chat.channel,
		       body: this.state.body };

	this.props.dispatch({
	    type: FancyActionTypes.CHAT_SENDING,
	    data: null
	});

	RealtimeClient.post('/morty/chat/send/', params)
	    .then((response) => {
		if(response.status === 200)  {
		    self.setState( { body: '' } );
		    if(document.getElementById(this.state.textAreaId))
			document.getElementById(this.state.textAreaId).focus();		    		    
		}
	    })
	    .catch((err) => {
		self.props.dispatch({
		    type: FancyActionTypes.CHAT_SEND_FAILURE,
		    data: "Something went wrong sending message"
		});
	    });
	
    }
    
    handler(type, event) {
	let value = event.target.value;
	let name = event.target.name;
	if(type == 'press') {
	    if(event.charCode == 13 && !event.shiftKey) {
		this.send();
	    }
	}
	if(type == 'change') {
	    event.preventDefault();	    
	    this.setState( { [name]: value });
	}
    }

    
    render() {
	let e = null;
	let chat = this.props.chat;

	if(chat.sendingStatusMessage)
	    e = <p>{chat.sendingStatusMessage}</p>;
	if(chat.sending) {
	    return <em>Sending...</em>;
	}

	let style = {
	    controlContainer: {
		width: "100%",
		marginTop: "1em",
		paddingTop: "1em",		
		// borderTop: "solid 1px #d2d2d2",
	    },
	    textarea: {
		fontSize: "120%",
		lineHeight: "140%",		
		border: "solid 1px #dfdfdf",
		borderTopLeftRadius: 5,
		borderBottomLeftRadius: 5,
		borderTopRightRadius: 5,				
		display: "table-cell",
		verticalAlign: "top",
		height: 120,
		padding: 5,
		width: "100%",
		resize: "none"
	    },
	    button: {
		display: "table-cell",
                float: "right",
		verticalAlign: "bottom",
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,				
		height: 50,
	    },
            icon: {
                fontSize: "150%"
            }
	};
	    

	if(chat) {
	    return (
		<div>
		  {e}
		  <div style={style.controlContainer}>
		    <textarea
		      style={style.textarea}
		      type="text"
		      id={this.state.textAreaId}
		      placeholder="Enter a message..."
		      name="body"
		      onKeyPress={(e) => this.handler('press', e)}
		      value={this.state.body}
		onChange={(e) => this.handler('change', e)} />
		    <br />
		      <button
			className="button blue"
			style={style.button}
		        onClick={this.send}>Send &rarr;	</button>
		  </div>
		</div>
	    );	    
	}
	return null;
    }
}
class ChatMessageFormatted extends React.Component {
    render() {
	let value = this.props.value;
	
	let lines = value.split('\n').map((item, key) => <span key={key}>{item}<br/></span>);
	let systemStyle = {
	    fontStyle: 'italic',
	    color: '#666',
	    fontSize: "100%",
	};
	let regularStyle = {
	    fontSize: "120%",
	    lineHeight: "140%"
	};
	return (
	    <div style={this.props.system ? systemStyle : regularStyle }>
	      { lines }
	    </div>
	);
    }
}
export class ChatMessage extends React.Component {
    render() {
	let message = this.props.message;
	let RADIUS = 7;
	let style = {
	    container: {
		padding: 10,
		marginBottom: 15
	    },
	    body: {
		textAlign: "left",
		backgroundColor: '#F4F4F4',
		color: "black",
		borderRadius: RADIUS,
		padding: 7,
		borderBottomLeftRadius: 0
	    },
	    credits: {
		float: "left",
		textAlign: "left",
		verticalAlign: "top",
		backgroundColor: '#F4F4F4',
		marginRight: 5,
		marginTop: 0,
		padding: 5,
		borderBottomLeftRadius: RADIUS,
		borderBottomRightRadius: RADIUS
	    }
	};
	
	if(window.pageVariables.user_key == message.user.key) {
	    style.body.backgroundColor = '#c5e8ff';
	    style.body.color = 'black';
	    style.body.borderBottomLeftRadius = RADIUS;
	    style.body.borderBottomRightRadius = 0;

	    style.body.textAlign = "right";
	    style.credits.textAlign = "right";
	    style.credits.float = "right";
	    style.credits.marginRight = 0;
	    style.credits.marginLeft  = 5;	    
	}

	let date = <FancyDate date={message.date_created} />;
	if(this.props.hideDate)
	    date = null;

	return (
	    <div style={style.container}>
	      <div style={style.body}>
		<ChatMessageFormatted system={message.system} value={ message.body } />
	      </div>
	      <div style={style.credits}>
		{ date }
		<AvatarInline user={message.user}/>
	      </div>
	    </div>
	);
    }
}

class ChatMessagesList extends React.Component {

    constructor(props) {
	super(props);
	this.state = { scrollerId: 'scroller-' + Math.ceil(Math.random() * 1000) } ;
    }

    componentDidUpdate() {
	/* keep it scrolled */
	let id = this.state.scrollerId;
	if(document.getElementById(id))
	    document.getElementById(id).scrollTop =
	    document.getElementById(id).scrollHeight;
    }
    
    render() {
	// return null;
	
	let messages = this.props.messages;
	let messageUi = null;
	if (messages.length)
	    messageUi = messages.map(message => <ChatMessage key={message.key} message={message} />);
	else
	    messageUi = <Spinner text="Waiting for messages..." />;

	let style = {
	    container: {
		height: 500,
		overflow: "scroll"
	    }
	};
	
	return (
	    <div id={this.state.scrollerId} style={style.container}>
	      { messageUi }
	    </div>
	);
    }
}

class ChatRoomSelector extends React.Component {
    render() {
	let roomsUi = this.props.rooms.map(room => <option key={room.slug} value={room.slug}>{room.name}</option>);

	return (
	    <select onChange={(e) => this.props.onSet(e.target.value)}>
	      <option>(Select a room)</option>
	      { roomsUi }
	    </select>
	);
    }
}

class ChatContainer extends React.Component {
    constructor(props) {
	super(props);

	this.onSet = this.onSet.bind(this);
	this.state = { loading: true,
		       channel: props.channel,
		       error: null,
		       rooms: [],
		       permission: props.channel };
	
    }
    
    onSet(channel) {
	this.setState( { channel: channel,
			 permission: channel });
	this.props.dispatch({
	    type: FancyActionTypes.CHAT_SET_CHANNEL,
	    data: channel
	});

	RealtimeClient.get('/morty/chat/messages/');
    }

    
    componentDidMount() {
	let self = this;
	
	this.onSet(this.props.channel || 'public');
	this.setState( { loading: false } );
    }

    render() {

	let style = {
	    container: {
		padding: "1em"
	    }
	};
	let channel = this.props.channel || 'public';
	
	if (this.state.loading)
	    return <Spinner text="Loading..." />;

	/* if we pass in chat as a parameter, it a bit wonky, so just update it here once */
	// console.log("Props: %o", this.props);

	let chat = this.props.chat;
	let messages = this.props.messages;

	/* if they didn't specicy a channel, let them pick */
	let selector = null;
	
	return (
	    <div style={style.container}>
	      {selector}
	      <ChatMessagesList messages={messages} />
		<ChatMessageCreate chat={chat} dispatch={this.props.dispatch} />
	    </div>
	);
    }
}


const mapStateToProps = (state, own) => {
    return {
	messages: state.project.chat.chat.messages,
	chat: state.project.chat.chat,
	dispatch: state.dispatch	
    };
    
    // return state;
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(FancyActionTypes, dispatch)
});

export default connect(mapStateToProps)(ChatContainer);
